<template>
  <div class="observer">

  </div>
</template>

<script>
export default {
    name: 'observer',
    data() {
        return {
          observer:null
        }
    },
    mounted() {
        this.observer = new IntersectionObserver(([entry])=>{
            if(entry && entry.isIntersecting) {
                this.$emit('intersect');
            }
        });
        this.observer.observe(this.$el);
    }
};
</script>

<style>
.observer {
  height: 1px;
}
/* ///////css below is used in projects//////// */
.multiselect .multiselect__content-wrapper::-webkit-scrollbar {
width: 10px;
height: 10px;
background-color: #F5F5F5; }
.multiselect .multiselect__content-wrapper::-webkit-scrollbar-thumb {
border-radius: 10px;
-webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
background-color: #9c9c9c; }
.multiselect__tag-icon:focus, .multiselect__tag-icon:hover {
    background: red;
}
.btn-outline-secondary {
    color: rgba(255, 255, 255, 0.849);
    background-color: rgb(223,113,27,0.8);
    border-color: rgb(223,113,27,0.8);
}
.btn-outline-secondary:hover {
    color: #fff;
    background-color: #DF711B;
    border-color: #DF711B;
}
#trending-projects input[type=radio] + label {
    padding: 0.5rem 0;
    margin-left: 0.5rem;
    margin-right: 1rem;
}
</style>